<div class="app-container">
  <app-header class="app-header" (toggleSideNav)="toggleSidenav()"></app-header>
  <mat-sidenav-container class="app-content-container">
    <mat-sidenav mode="side" [opened]="sidenavOpened()" class="app-sidenav-container" ppSidenavAutosize>
      <app-sidenav></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content class="app-sidenav-content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-footer class="app-footer"></app-footer>
</div>
